import {
  computedPenId,
  type ComputedTrendSeries,
} from 'features/timeSeries/computed/computedTrendStore'

interface UnitBearingEntry {
  id: string
  data: { unit?: string | null }
}

/**
 * Computed pens that may share their base pen's y-scale: only when the base is
 * a known sensor whose unit matches, since a series in another unit would be
 * squashed onto the wrong axis and its own axis range would never apply.
 */
export function computedScalePairsFor(
  computedSeries: readonly ComputedTrendSeries[],
  sensorEntries: readonly UnitBearingEntry[]
): Map<string, string> {
  const unitById = new Map(
    sensorEntries.map((entry) => [entry.id, entry.data.unit ?? null])
  )
  const pairs = new Map<string, string>()
  computedSeries.forEach((series) => {
    const base = series.baseEntryId
    if (!base || !unitById.has(base)) return
    if ((series.units ?? null) !== unitById.get(base)) return
    pairs.set(computedPenId(series.entryId), base)
  })
  return pairs
}
